import { useState } from 'react'
import FormLayout from 'src/app/layout/form-layout/form-layout'
import { FormLayoutProps } from 'src/app/layout/form-layout/form-layout.types'
import { Alert } from '@vapor/material'
import { ResourceTypeTimeUnitOfMeasurement, useResourceTypesQuery } from 'src/api/api.generated'
import { useTranslation } from 'react-i18next'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useLocalizeString from 'src/app/hooks/current-locale/use-localized-string'
import ReservationTimeNewForm from './reservation-time-new.form'
import { ResourceTypeProps } from './reservation-time-new-form.types'

type ReservationTimeNewFormProps = {
  reservationId?: string
  formLayoutProps: Omit<FormLayoutProps, 'toolbarContents' | 'title' | 'toolbar'>
  propertyId: string
  onSubmitAndOpenReservation?: (reservationId: string) => void
  onCancel: () => void
  onSubmitComplete: () => void
  resourceTypeId: string
  resourceId?: string
  start?: Date
  end?: Date
  from?: Date
  to?: Date
}

export const ReservationTimeNewFormWrapper = (props: ReservationTimeNewFormProps) => {
  const { formLayoutProps, onSubmitAndOpenReservation, resourceTypeId } = props
  const { id: tenantId } = useTenant()
  const { t } = useTranslation()

  return (
    <RequiredTimeResourceType
      tenantId={tenantId}
      propertyId={props.propertyId}
      resourceTypeId={resourceTypeId}
      render={(data) => {
        if (data) {
          return <ReservationTimeNewForm {...props} {...data} />
        } else {
          return (
            <FormLayout
              title={t('pms.booking.reservation.reservation_time_creation.title', { timeResourceType: name })}
              {...formLayoutProps}
              appearance={{ ...formLayoutProps.appearance }}
              toolbar={<></>}
            >
              <Alert variant="standard" severity="error">
                {t('pms.booking.reservation.reservation_time_creation.not_valid_type')}
              </Alert>
            </FormLayout>
          )
        }
      }}
    />
  )
}

type RequiredTimeResourceTypeProps = {
  tenantId: string
  propertyId: string
  resourceTypeId: string
  render: (timResourceTypeData: ResourceTypeProps | undefined) => JSX.Element
}

const RequiredTimeResourceType = (props: RequiredTimeResourceTypeProps) => {
  const { tenantId, propertyId, resourceTypeId, render } = props
  const localizeString = useLocalizeString()
  const [resourceType, setResourceType] = useState<ResourceTypeProps>()

  useResourceTypesQuery({
    variables: { filter: { tenantId: { eq: tenantId }, propertyId: { eq: propertyId }, id: { eq: resourceTypeId } } },
    onCompleted(data) {
      if (data.resourceTypes) {
        const timeResourceType = data.resourceTypes.find((rt) => rt.timeConfiguration)
        if (timeResourceType && timeResourceType.timeConfiguration?.chargeCategoryId)
          setResourceType({
            unitOfMeasurement: timeResourceType.timeConfiguration?.unitOfMeasurement || ResourceTypeTimeUnitOfMeasurement.HOUR,
            name: timeResourceType.code || localizeString(timeResourceType.customName) || localizeString(timeResourceType.name.description),
            activity: timeResourceType.timeConfiguration?.activity || undefined,
            inventory: timeResourceType.inventory,
            rackRate: timeResourceType.rackRate,
            minRate: timeResourceType.minRate,
            chargeCategoryId: timeResourceType.timeConfiguration.chargeCategoryId,
          })
      }
    },
  })

  return <>{render(resourceType)}</>
}
